module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "Page_iii",
      "title": "[iii]"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("With Washington in the West")]), _vm._v("” is a complete\nstory in itself, but forms the first of several\nvolumes to be known by the general title of “Colonial\nSeries.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The main character of the book is David Morris,\nthe son of a hardy pioneer who first settles near Will’s\nCreek (now the town of Cumberland, Virginia),\nand later on establishes a trading-post on one of the\nnumerous tributaries of the Ohio River.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As a boy David becomes acquainted with George\nWashington, then but a young man of seventeen.\nWashington is at work, surveying tracts of land in\nthe beautiful Shenandoah valley, and David is glad\nenough to go with him as an assistant. Together\nthey ford the rivers and creeks, and climb the mountains,\nand they do not separate until the ill health of\nLawrence Washington compels his brother to return\nhome.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The coming of the English traders into the valley\nof the Ohio was viewed with suspicion by the French,\nand it was not long before these traders were served\nwith notices to quit. A notice reaching Mr. Morris,"), _c('span', {
    attrs: {
      "id": "Page_iv",
      "title": "[iv]"
    }
  }), _vm._v("\nhe turned it over to his son, who was to take it\nto the Virginia authorities and learn whether or not\nit must be respected. On his way eastward David\nfalls in with the Virginia Rangers, who are under\nthe command of Washington, and learns that there\nis practically a state of war between the English and\nFrench in America. Several trading-posts have been\nattacked and this being so the youth becomes anxious\nto return to his father, and throws in his fortunes\nwith Washington as a young soldier. Then follows\nthe march to Great Meadows, the defence of Fort\nNecessity, and the news that Mr. Morris’ post has\nbeen captured by the French and the trader taken\nprisoner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Chafing to learn what has become of his parent,\nDavid remains at the home of his uncle until the\nnext Spring, when General Braddock arrives with his\ntroops from England. Another campaign against\nthe French is now opened and once again the youth\nbecomes a soldier boy, to witness Braddock’s bitter\ndefeat and Washington’s masterly effort to save the\nremnant of the army from annihilation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In the preparation of the historical portions of this\nwork numerous authorities have been consulted, including\nthe Writings of Washington, biographies by\na great number of more or less well-known authors,\nand several colonial histories and books of record."), _c('span', {
    attrs: {
      "id": "Page_v",
      "title": "[v]"
    }
  }), _vm._v("\nFor this reason the author trusts that it is free from\nany error sufficient to hurt its usefulness. As a\nstory the writer hopes it will find equal favor with\nthe many which have preceded it from his pen.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Edward Stratemeyer.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Newark, N. J.")]), _vm._v(","), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('i', {
    staticClass: "calibre12"
  }, [_vm._v("May 20, 1901")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_vi",
      "title": "[vi]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0